export {}

let env = 'prod'

if (typeof window !== 'undefined') {
	let storedEnv

	try {
		storedEnv = JSON.parse(localStorage.getItem('env') ?? '')
	} catch (e) {
		storedEnv = localStorage.getItem('env')
	}

	if (storedEnv !== null) {
		env = storedEnv
	}
} else if (
	typeof process !== 'undefined' &&
	process.env.NEXT_PUBLIC_ENVIRONMENT
) {
	env = process.env.NEXT_PUBLIC_ENVIRONMENT
}

export default env
